import React, { useState } from 'react';
import { connect } from 'react-redux';
import { MUIDataTableColumn, MUIDataTableOptions } from 'mui-datatables';
import { Navigator } from 'src/services';
import { PATHS } from 'src/appConfig/paths';

import { IAppState } from 'src/store';
import { View, Table, Text } from 'src/components/common';
import appConfig from 'src/appConfig';
import { IListDeposition } from '../type';
import { getDepoStatusTab, StatusOptions } from '../helper';
import { ErrorService } from 'src/services';
import { IconButton, Tooltip } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import NewDeposition from '../NewDeposition';
import { depositionAction } from 'src/redux/depositionRedux';
import { getSortParam } from 'src/utils';
import CourtReporterText from './CourtReporterText';

const ManageDepositions: React.FC<Props> = ({ isLoading, onGetDepositions }) => {
  const [records, setRecords] = useState<IListDeposition[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [refresh, doRefresh] = useState<number>(0);
  const [isAddingDeposition, setIsAddingDeposition] = useState<boolean>(false);

  const handleGetDepositions = (params: any) => {
    const searchParams = {
      search: params.search ?? '',
      status: params.status ?? [],
      sort: params.sort ? getSortParam(params.sort) : 'OPEN_DATE',
      order: params.order ? params.order.toUpperCase() : 'DESC',
      skip: params.skip ?? '0',
      take: params.take ?? '10',
    };
    onGetDepositions(searchParams, onGetDepesitionsSuccess, ErrorService.handler);
  };

  const onGetDepesitionsSuccess = (depositions: any, total: number) => {
    setRecords(depositions);
    setTotal(total);
  };
  const navigateToDetailPage = (id: string) => {
    Navigator.navigate(`${PATHS.DepositionManagement}/${id}`);
  };

  const handleRowClick = (_value: any, meta: { rowIndex: number }) => {
    const index = meta.rowIndex;
    const selectedRecord = records[index];
    //Navigate to Detail Page
    navigateToDetailPage(selectedRecord.id);
  };
  const handleOpenModalAddDeposition = () => {
    setIsAddingDeposition(true);
  };
  const handleCloseModalAddDeposition = (needReload?: boolean, id?: string) => {
    setIsAddingDeposition(false);
    if (needReload) refreshTable();
    if (id !== undefined) navigateToDetailPage(id);
  };
  const refreshTable = () => {
    doRefresh(prev => prev + 1);
  };
  const tableOptions: MUIDataTableOptions = {
    rowsPerPageOptions: appConfig.ROWS_PER_PAGE_OPTIONS,
    count: total,
    onRowClick: handleRowClick,
    customToolbar: () => (
      <Tooltip title={'Create a New Deposition'}>
        <IconButton onClick={handleOpenModalAddDeposition}>
          <Add />
        </IconButton>
      </Tooltip>
    ),
  };

  const checkInStatus = Object.values(StatusOptions);
  const columns: MUIDataTableColumn[] = [
    { name: 'caseName', label: 'Case Name', options: { filter: false, sort: true } },
    { name: 'caseId', label: 'Depo ID', options: { filter: false, sort: true } },
    { name: 'name', label: 'Depo Name', options: { filter: false, sort: true } },
    { name: 'openDate', label: 'Open Date', options: { filter: false, sort: true } },
    { name: 'actualDate', label: 'Actual Depo Date', options: { filter: false, sort: true } },
    {
      name: 'courtReporter',
      label: 'Court Reporter',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (_value: string, metaTable: { rowIndex: number }) => {
          const index = metaTable.rowIndex;
          const currentRecord = records[index];

          if (['PENDING', 'REJECTED'].includes(currentRecord.status)) {
            return <Text>-- --</Text>;
          }
          return <CourtReporterText involvedPartiesUri={currentRecord.subResources.involvedPartiesUri} />;
        },
      },
    },

    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        filterOptions: {
          fullWidth: true,
          names: checkInStatus,
        },
        sort: true,
        customBodyRender: (value: string) => {
          return getDepoStatusTab(value);
        },
      },
    },
  ];

  return (
    <View className="mt-32">
      {isAddingDeposition && <NewDeposition onClose={handleCloseModalAddDeposition} />}
      <Table
        title="Deposition Management"
        data={records}
        tableOptions={tableOptions}
        columns={columns}
        onAction={handleGetDepositions}
        refresh={refresh}
      />
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
  content: state.content,
});

const mapDispatchToProps = {
  onGetDepositions: depositionAction.getDepositions,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageDepositions);
